import React from "react";
import { useNavigate } from "react-router-dom";

import { getIcon } from "../../../helpers/icons";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Section from "../../../components/Section";
import Background from "../../../components/Background";
import CategoryList from "../../../components/CategoryList";

import style from "./style.module.css";

export default function PageBanner(props) {
    const {
        media_type = "",
        preview_image = "",
        name = "",
        categories = [],
        themes = [],
        series = [],
        tags = [],
        backButton = true,
        size = "2560x490"
    } = props;
    const navigate = useNavigate();

    return (
        <div className={`${style.pageBanner} ${media_type !== "" ? style[media_type] : ''}`}>
            <Background src={preview_image} size={size} cPosition="topRight" />
            <Section className={style.pageBannerWrap}>
                {
                    backButton === true && (
                        <div className={style.backButtonWrap}>
                            <Link 
                                onClick={() => { navigate(-1) }} 
                                className={`${style.backButton}`}
                            >
                                <i className={getIcon("Arrow-left")}></i>
                            </Link>
                        </div>
                    )
                }
                <div className={`pageBannerContent ${style.pageBannerContent}`}>
                    <div className={style.sectionRow}>
                        <div className={style.sectionColumn}>
                            {
                                (categories.length > 0 || themes.length > 0 || series.length > 0 || tags.length > 0) && (
                                    <div className={style.categoryRow}>
                                        {
                                            categories.length > 0 && (
                                                <CategoryList type="category" item={categories} />
                                            )
                                        }
                                        {
                                            series.length > 0 && (
                                                <CategoryList item={series} />
                                            )
                                        }
                                    </div>
                                )
                            }
                            {
                                name !== "" && (
                                    <Title className="bigTitle">{name}</Title>
                                )
                            }
                        </div>
                    </div>
                </div>
            </Section>
        </div>
    )
}